import { render, staticRenderFns } from "./RoyalShip.vue?vue&type=template&id=20b274ea&scoped=true"
import script from "./RoyalShip.vue?vue&type=script&lang=js"
export * from "./RoyalShip.vue?vue&type=script&lang=js"
import style0 from "./RoyalShip.vue?vue&type=style&index=0&id=20b274ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b274ea",
  null
  
)

export default component.exports